var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"shadow"},[_c('top-nav-bar')],1),_c('div',{staticClass:"app-content app-slim-scroll"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }